<template>
    <div>
      <topic-write-link v-for="writeLayout in writeLayouts" :key="`topicComp${writeLayout}`" :writeLayout="writeLayout" :topicData="topicData" :Categories="Categories"></topic-write-link>
    </div>
</template>

<script>
import TopicListLink from "@/components/topic/TopicListLink";
import TopicWriteLink from "@/components/topic/TopicWriteLink";
import topicUtil from "@/components/topic/topicUtil";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import elFileMixins from "@/mixins/elFileMixins";
import EventBus from "@/utils/event-bus";
import DeleteClass from "@/mixins/deleteClass";
import topicValidator from "@/mixins/validators/topicValidator";
  export default {
    name: "TopicWriteComponent",
    mixins: [topicUtil, alertMixins, elFileMixins,topicValidator],
    components: {TopicWriteLink, TopicListLink},
    provide() {
      return {
        topicWriteSetData: this.setData,
      }
    },
    inject: ['changeLoading'],
    props: {
      topicType: {default: ''},
      topicKey: {default: 0},
    },
    data() {
      return {
        writeLayouts: [],
        getCategoryFunc: '',
        categoryApiParamsSet: {},
        getFunc: '',
        detailApiParamsSet: {},
        getDetailParamsKey: 'id',
        writeFunc: '',
        writeApiParamSet: {},
        parsingData: {},
        fileInfo: [],
        directUrl: '',
        directType: '',
        keyName: '',
        writeSuccessType: 1,
        writeFailTypes: {},
        fileType: '',

        deleteFunc:'',
        deleteApiParamsSet: {},
        deleteSuccessType: '',
        deleteFailTypes:{},

        topicData: {},
        Categories: [],

        isCategory:false,

        imageOptionDeleteClass: null,
      }
    },
    async created() {
      this.initFilterConfig();
        await this.getCategory();
      if(this.topicKey === 0) {
        this.initTemplateConfig();
      }else{
        this.getTopic();
      }
    },
    mounted() {
      EventBus.$on('writeTopic', this.writeTopic);
      EventBus.$on('deleteTopic', this.runDeleteConfirm);

    },
    beforeDestroy() {
      EventBus.$off('writeTopic')
      EventBus.$off('deleteTopic')

    },
    destroyed() {},
    computed: {
    },
    methods: {
      setData(type, value) {
        this[type] = value;
      },
      initTemplateConfig() {
        let config = this.returnTopicConfig(this.topicType);
        this.writeLayouts = config.writeLayouts
      },
      initFilterConfig() {
        let config = this.returnTopicConfig(this.topicType);
        this.getCategoryFunc =  config.getCategoryFunc;
        this.categoryApiParamsSet = config.categoryApiParamsSet;
        this.isCategory = config.isCategory;

        this.getFunc = config.getFunc;
        this.detailApiParamsSet = config.detailApiParamsSet;
        this.getDetailParamsKey = config.getDetailParamsKey;
        this.writeFunc = config.writeFunc;
        this.writeApiParamSet = config.writeApiParamSet;
        this.parsingData = config.parsingData;
        this.fileInfo = config.fileInfo;
        this.directUrl = config.directUrl;
        this.directType = config.directType;
        this.keyName = config.keyName;
        this.writeSuccessType = config.writeSuccessType;
        this.writeFailTypes = config.writeFailTypes;

        this.deleteFunc = config.deleteFunc;
        this.deleteApiParamsSet = config.deleteApiParamsSet;
        this.deleteSuccessType = config.deleteSuccessType;
        this.deleteFailTypes = config.deleteFailTypes;

        this.newDeleteClass();
      },
       getCategory() {
        let $this = this;
        return new Promise(function(resolve, reject) {
            if(util.isEmpty($this.getCategoryFunc)) {
            resolve(false);
          }
          let params = Object.assign({}, $this.categoryApiParamsSet);

          try {
            $this.$api.$online[$this.getCategoryFunc](params).then(res => res.Data.Result).then(res => {
              if(res.Info.type === 1) {
                res.List.forEach((data,index) => {
                  if(data.oc_lock ===1){ // 직접입력 제거
                    res.List.splice(index, 1);
                  }
                })
                $this.Categories = res.List;
                resolve();
              }
            })
          }catch (e) {
            console.log(e);
            resolve();
          }
        })
       
      },
      getTopic(){
        let params = Object.assign({}, this.detailApiParamsSet);
            params[this.getDetailParamsKey] = this.topicKey
        try {
          this.$api.$online[this.getFunc](params).then(res => res.Data.Result).then(res => {
         if(res.Info.type === 1 && res.List.length > 0) {
             this.topicData = res.List[0];
              this.initTemplateConfig();
            }else{
           this.createAlert({
             content: '데이터를 불러올 수 없습니다.',
             hide: () => {
               this.$router.back();
             }
           })
         }
          })
        }catch (e) {
          console.log(e);
        }
      },
      writeTopic() {
        let dataKeys = Object.keys(this.parsingData);
        this.$validate(dataKeys).then((success) => {
          if(!success) {
            util.Array.each(this.writeLayouts, (layout, index, arr) => {
              EventBus.$emit(`${layout}Validator`);
            })
            this.errorAlert('필수데이터를 확인해주세요.');
            return false;
          }
          this.changeLoading(true);
          let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
          dataKeys = Object.keys(this.parsingData);
          dataKeys.forEach(dataKey => {
            params[this.parsingData[dataKey]] = this[dataKey];
          })
          if(this.topicKey != 0) { // 수정
            params[this.keyName] = this.topicKey;
          }
          try {
            this.$api.$online[this.writeFunc](params)
              .then(res => res.Data.Result)
              .then(async (res) => {
                let type = this.returnTopicWriteType(res.Info.type);
                if(type != true) {
                  this.errorAlert(type);
                  this.changeLoading(false);
                  return false;
                } else {
                  if (!util.isEmpty(this.deleteFiles)) {
                    this.removeFiles(this.deleteFiles);
                  }

                  await this.uploadFile(this.topicKey > 0 ? this.topicKey : Number(res.List.ot_idx));

                  this.afterFunc();
                  EventBus.$emit("apiLoading", false);
                }
              })
          }catch (e) {
            this.changeLoading(false);
            console.log(e)
          }
        })
      },
      uploadFile(key) {
        util.Array.each(this.fileInfo, (data, index, arr) => {
            let file = this[data.fileName];
            let checkFile = !util.isEmpty(file) && file.filter((files) => files.hasOwnProperty("raw")).length > 0;
            if (checkFile) {
                for (let i = 0; i < this.files.length; i++) {
                    file[i].a_seq = i;
                }
                this.uploadFiles(file, data.fileType, key).then(success => {
                });
            }
        });
      },
      afterFunc(){
        this.changeLoading(false);
        this.createAlert(
            {
              content: '저장되었습니다.',
              btnText: '확인',
              hide: () => {
                if (this.directType === 'back') {
                  this.$router.back();
                  return false;
                }
                if (this.directUrl === '') {
                  return false;
                }
                let url = this.directUrl;
                this.$router.push(url);
              }
            })
      },
      returnTopicWriteType(type) {
        if(type == this.writeSuccessType) {
          return true;
        }else{
          return util.isEmpty(this.writeFailTypes[type]) ? '저장에 실패하였습니다.' : this.writeFailTypes[type]
        }
      },
      newDeleteClass() {
        let deleteOptions = {
          func: this.$api.$online[this.deleteFunc],
          apiParamSet: this.deleteApiParamsSet,
          successType: this.deleteSuccessType,
          errorTypes: this.deleteFailTypes,
          keyName: this.keyName,
          afterFunc: this.deleteAlertFunc,
        };
        this.DeleteClass = new DeleteClass(deleteOptions);
      },
      runDeleteConfirm(idx) {
        this.createConfirm({
          content: '정말 삭제하시겠습니까?',
          confirm: () => {
            this.DeleteClass.runDelete(idx);
          }
        })
      },
      deleteAlertFunc() {
        this.changeLoading(false);
        this.createAlert({
          content: '삭제 되었습니다.',
          hide: () => {
            this.$router.back();
          }
        })

      },
    },
    watch: {},
  }
</script>

<style scoped>

</style>
